import { AxiosError, AxiosResponse } from 'axios'

import { axiosServer as axios } from '@/base/axios'

// ponytail: retry fisso 3x senza backoff, sufficiente per errori di rete/5xx transitori del CMS durante la build
const RETRIES = 3

export const getPromiseFromFetch = async <T = any>({
  params = {},
  config = {},
  method = 'get',
  url = ''
}): Promise<AxiosResponse<T>> => {
  let res: AxiosResponse<T> | undefined
  for (let i = 0; i < RETRIES; i++) {
    res = await (axios as any)
      [method](url, params, config) // eslint-disable-line
      .catch((error: AxiosError) => error.response)
    if (res && res.status < 500) break
  }
  return res as AxiosResponse<T>
}
